import * as PropTypes from 'prop-types';
import * as React from 'react';
import { useRef, useState, useLayoutEffect } from 'react';

var StickyScript = props => {
  var {
    children
  } = props;
  var stickyRef = useRef(null);
  var stickyWrapperRef = useRef(null);
  var [elWidth, setElWidth] = useState('');
  var [elHeight, setElHeight] = useState('');
  var [elClass, setElClass] = useState('');
  var [wrapClass, setWrapClass] = useState('');
  useLayoutEffect(() => {
    var _stickyRef$current, _stickyRef$current$ge;
    setElHeight("".concat((_stickyRef$current = stickyRef.current) === null || _stickyRef$current === void 0 ? void 0 : (_stickyRef$current$ge = _stickyRef$current.getBoundingClientRect()) === null || _stickyRef$current$ge === void 0 ? void 0 : _stickyRef$current$ge.height, "px"));
    var scrollHandler = () => {
      var _stickyWrapperRef$cur, _stickyRef$current2;
      var stickyWrapperBoundingClientRect = (_stickyWrapperRef$cur = stickyWrapperRef.current) === null || _stickyWrapperRef$cur === void 0 ? void 0 : _stickyWrapperRef$cur.getBoundingClientRect();
      var stickyBoundingClientRect = (_stickyRef$current2 = stickyRef.current) === null || _stickyRef$current2 === void 0 ? void 0 : _stickyRef$current2.getBoundingClientRect();
      var stickyWrapperTop = stickyWrapperBoundingClientRect === null || stickyWrapperBoundingClientRect === void 0 ? void 0 : stickyWrapperBoundingClientRect.top;
      setElWidth("".concat(stickyWrapperBoundingClientRect === null || stickyWrapperBoundingClientRect === void 0 ? void 0 : stickyWrapperBoundingClientRect.width, "px"));
      setElHeight("".concat(stickyBoundingClientRect === null || stickyBoundingClientRect === void 0 ? void 0 : stickyBoundingClientRect.height, "px"));
      if (stickyBoundingClientRect && (stickyBoundingClientRect === null || stickyBoundingClientRect === void 0 ? void 0 : stickyBoundingClientRect.top) < 1 && stickyWrapperTop && stickyWrapperTop < 1) {
        setElClass(' stick');
        setWrapClass(' stick-wrapper');
      } else {
        setElClass('');
        setWrapClass('');
      }
    };
    window.addEventListener('scroll', scrollHandler);
    window.addEventListener('resize', scrollHandler);
    return () => {
      window.removeEventListener('scroll', scrollHandler);
      window.removeEventListener('resize', scrollHandler);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: stickyWrapperRef,
    className: "sticky-wrapper".concat(wrapClass),
    style: {
      height: elHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: stickyRef,
    className: "sticky".concat(elClass),
    style: {
      width: elWidth
    }
  }, children));
};
StickyScript.propTypes = {
  children: PropTypes.element.isRequired
};

export { StickyScript };
